import {AlertingBase, BaseModel} from './baseModel';

export class ApiKey extends BaseModel {
  issued_at?: string;
  expires_at?: string;
  last_used?: string;
  entity_id?: string;
  jwt?: string;         // Only provided after creation
}

export type ApiKeys = Array<ApiKey>;
export type AlertingApiKey = AlertingBase<ApiKey>;
export type AlertingApiKeys = AlertingBase<ApiKeys>;

export const Storage_Token_Key = "api-token";
export class ApiToken {
    ttl?: number;
    key?: string;
}
